import * as React from 'react'

import { SCREENS } from './workflow'

const init = Object.keys(SCREENS) as AdminRoleStep[]

const useWorkflow = (form: AdminRoleForm, edit?: AdminRoleStep) => {
  const [workflow, setWorkflow] = React.useState(init)

  React.useEffect(() => {
    const next = init

    // add rules on workflow
    // every rule defined workflow cut

    // *************************************************
    //                  content rules
    // *************************************************

    // keep only one screen for update
    const PartialUpdateRule = edit ? ['info', 'scope'].filter((s) => s !== edit) : []

    //combined every rules
    const wf = next.filter((w) => !PartialUpdateRule.includes(w))

    setWorkflow(wf)
  }, [form, edit])

  return [workflow] as const
}

export default useWorkflow
